import React from 'react';
import { observer } from 'mobx-react';
import { Typography, Box } from '@material-ui/core';
import { useStores } from '../../hooks/use-stores';
import Loader from '../Loader';
import { useStyles } from './style';

const NextLevel = observer(() => {
    const classes = useStyles();
    const { LoyaltyStore: store } = useStores();
    const nextLevel = store.levels.length ? store.levels[parseInt(store.userLevelInfo.level) + 1] : null;

    return (
        <Box className={classes.card}>
            <Typography className={classes.heading}>Следующий уровень</Typography>

            {store.loading && <Loader p={1} size={40} />}
            {!store.loading && nextLevel && (
                <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
                    <Box width={62} mr={3}>
                        <img src={nextLevel.image_available} alt="" className={classes.levelIcon} />
                    </Box>
                    <Box flex={1}>
                        <Typography variant="body2" className={classes.levelTitle}>
                            {nextLevel.name}
                        </Typography>
                        <Typography variant="body2">{nextLevel.points} баллов</Typography>
                    </Box>
                </Box>
            )}
        </Box>
    );
});

export default NextLevel;
